import ErrorPayload from "@/common/utils/error/errorPayload";

export function createErrorPayload(error) {
  let message = null;
  if (error.status) {
    message = `Error ${error.status}: ${error.message}`;
  } else {
    message = `Something has gone wrong - ${error.message}`;
  }
  return new ErrorPayload(error, message, error.status || -1);
}
